import { Technologies } from './../definitions/data-store/technologies';
import { BehaviorSubject, Observable } from 'rxjs';
export abstract class PageDataService {
    protected widgetsSubject: BehaviorSubject<any[]> = new BehaviorSubject(null);
    widgetsData$: Observable<any[]> = this.widgetsSubject.asObservable();

    abstract getPageData(id?: string|number): Observable<any>;
    abstract setWidgetsData(data: any): void;
}
